import React, { useEffect, useState } from "react";
import Header from "../../components/landingPage/Header";
import { useParams } from "react-router-dom";
import InputField from "../../components/b2b/InputField";

import {
  faKey,
  faEye,
  faEyeSlash,
} from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { faK } from "@fortawesome/free-solid-svg-icons";
import Footer from "../../components/landingPage/Footer";

const ResetPassword = () => {
  const { token } = useParams();
  const [tokenvalidmsg, settokenvalidmsg] = useState("");
  const [password, setpassword] = useState();
  const [confirmpassword, setconfirmpassword] = useState();
  const [errMSg, seterrMSg] = useState("");
  const [successMsg, setsuccessMsg] = useState("");
  const [loading, setloading] = useState(false);
  const [isPasswordVisible, setisPasswordVisible] = useState(false);
  const [isPasswordVisible2, setisPasswordVisible2] = useState(false);

  const checkTokenValidOrNot = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/user/checkToken?token=${token}`
    );
    settokenvalidmsg(response.data.msg);
  };

  useEffect(() => {
    checkTokenValidOrNot();
  }, []);

  const resetPassword = async () => {
    if (password !== confirmpassword) {
      seterrMSg("Password and confirm password does not match");
    } else {
      seterrMSg("");
      setloading(true);
      const response = await axios.post(
        ` ${process.env.REACT_APP_BASE_URL}/user/resetPassword?token=${token}`,
        {
          password,
        }
      );

      if (!response?.data?.success) {
        setloading(false);
        seterrMSg(response.data.message);
      } else {
        setloading(false);
        setsuccessMsg(response.data.message);
      }
    }
  };

  return (    
    <div>
      <Header className="static" />
      <div>
        <img
            src={require("../../assets/images/login_landing.jpg")}
            alt=""
            className="hidden sm:block h-[26rem] md:h-[26rem] lg:h-[36rem] xl:h-[42rem] w-screen object-cover"
        />
        <div className="bg-black sm:transparent sm:hidden w-screen h-96 object-cover"></div>
        <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-[24rem] sm:h-[26rem] md:h-[26rem] lg:h-[36rem] xl:h-[42rem] opacity-80 absolute top-0"></div>

        <div className="h-full opacity-100 w-full pt-3 absolute px-5 transform -translate-y-80 sm:-translate-y-[350px] md:-translate-y-[340px] lg:-translate-y-[450px] xl:-translate-y-[550px]">          
          <div className="mt-10 text-3xl font-semibold text-center text-white pb-6 sm:pb-14">Reset your Password</div>          

          <div className="flex-col space-y-4  justify-center items-center">
            <form className="flex-wrap mx-auto space-y-3 w-80 sm:w-96">
              {errMSg && <div className="text-red-500">{errMSg}</div>}
              {successMsg && <div className="text-teal-500">{successMsg}</div>}
              <div className="relative">
                <InputField
                  isFontawesome={true}
                  fontawesomeIcon={faKey}
                  id="password"
                  name="password"
                  placeholder="Enter new password"
                  onChange={(e) => {
                    //   setEmail(e.target.value);
                    setpassword(e.target.value);
                  }}
                  type={isPasswordVisible ? "text" : "password"}
                />
                <div className="absolute top-3.5 right-2">
                    {!isPasswordVisible ? (
                      <FontAwesomeIcon
                        className="cursor-pointer"
                        icon={faEye}
                        onClick={() => {
                          setisPasswordVisible(!isPasswordVisible);
                        }}
                      />
                    ) : (
                      <FontAwesomeIcon
                        className="cursor-pointer"
                        icon={faEyeSlash}
                        onClick={() => {
                          setisPasswordVisible(!isPasswordVisible);
                        }}
                      />
                    )}
                </div>
              </div>
              <div className="relative">
                <InputField
                  isFontawesome={true}
                  fontawesomeIcon={faKey}
                  placeholder="Confirm new password"
                  id="confirm_password"
                  name="confirm_password"
                  type={isPasswordVisible2 ? "text" : "password"}
                  onChange={(e) => {
                    //   setEmail(e.target.value);
                    setconfirmpassword(e.target.value);
                  }}
                />
                <div className="absolute top-3.5 right-2">
                    {!isPasswordVisible2 ? (
                      <FontAwesomeIcon
                        className="cursor-pointer"
                        icon={faEye}
                        onClick={() => {
                          setisPasswordVisible2(!isPasswordVisible2);
                        }}
                      />
                    ) : (
                      <FontAwesomeIcon
                        className="cursor-pointer"
                        icon={faEyeSlash}
                        onClick={() => {
                          setisPasswordVisible2(!isPasswordVisible2);
                        }}
                      />
                    )}
                </div>
              </div>                
              <div
                // onClick={sendEmail}
                onClick={() => {
                  resetPassword();
                }}
                className="text-white text-center uppercase bg-secondary hover:bg-gray-700 cursor-pointer w-full font-normal py-1.5 rounded-sm mt-10"
              >
                {loading ? "Resetting..." : "Reset"}
              </div>
            </form>
          </div>
        </div>
        
      </div>
      <Footer />
    </div>    
  );
};

export default ResetPassword;
